<nz-card [nzBordered]="false" [nzTitle]="cardTitle">
  <ng-template #cardTitle>
    <div class="header">
      <laveo-card-header
        title="Rapport : Caractéristiques des prestations"
        [description]="description"
        [backButtonEnabled]="true"
        (backButtonClick)="back()"
        [isLoading]="isLoading"
        buttonTitle="Export excel"
        buttonIcon="download"
        (buttonClick)="export()"
      ></laveo-card-header>
    </div>
  </ng-template>
  <div nz-row [nzGutter]="[16, 16]">
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <div nz-row nzGutter="8" class="mt-8">
        <div nz-col [nzSm]="24" [nzMd]="12" [nzXl]="8" *ngIf="userCanChooseSelectedRole">
          <nz-form-item>
            <nz-form-label nzFor="group">Grouper par</nz-form-label>
            <nz-form-control>
              <nz-select
                id="role"
                nzSize="large"
                nzPlaceHolder="Grouper par"
                [nzShowArrow]="true"
                [nzShowSearch]="true"
                formControlName="role"
                [style.minWidth]="'200px'">
                <nz-option
                  [nzLabel]="UserRoleType.customer | roleName"
                  [nzValue]="UserRoleType.customer">
                </nz-option>
                <nz-option
                  [nzLabel]="UserRoleType.customerSite | roleName"
                  [nzValue]="UserRoleType.customerSite">
                </nz-option>
                <nz-option
                  [nzLabel]="UserRoleType.structure | roleName"
                  [nzValue]="UserRoleType.structure">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSm]="24" [nzMd]="12" [nzXl]="8">
          <nz-form-item>
            <nz-form-label nzFor="dates">Dates</nz-form-label>
            <nz-form-control>
              <nz-range-picker id="dates" class="w-100-p" nzSize="large" nzFormat="dd/MM/yyyy" formControlName="dates" [nzRanges]="dateRanges" [nzAllowClear]="false"></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <nz-table
      nzBordered
      nzShowSizeChanger
      [nzScroll]="{ x: '4000px' }"
      [nzData]="data ? data.data : []"
      [nzFrontPagination]="false"
      [nzLoading]="isLoading"
      [nzTotal]="data ? data.metadata.totalResults : 0"
      [nzPageSize]="limit"
      [nzPageIndex]="currentPage ? currentPage : 1"
      [nzNoResult]="emptyTemplate"
      (nzQueryParams)="setPage($event)"
      *ngIf="!error; else errorTemplate">
      <thead>
        <tr>
          <th nzLeft nzColumnKey="customer" *ngIf="selectedRole === UserRoleType.customerSite" [rowSpan]="2">Client</th>
          <th nzLeft [nzColumnKey]="selectedRole" [rowSpan]="2">{{ selectedRole | roleName }}</th>
          <th type="total" rowspan="2">Type de lavage</th>
          <th nzColumnKey="total" rowspan="2">Prestations (total)</th>
          <th nzColumnKey="vehicleStateEnabled" colspan="2">État des lieux</th>
          <th nzColumnKey="conveying" colspan="2">Convoyage</th>
          <th nzColumnKey="sticking" colspan="2">Stickage</th>
          <th nzColumnKey="desticking" colspan="2">Déstickage</th>
          <th nzColumnKey="contactZoneDisinfection" colspan="2">Désinfection zones contact</th>
          <th nzColumnKey="interiorDisinfection" colspan="2">Désinfection habitacle</th>
          <th nzColumnKey="finishing" [colspan]="serviceFinishings.length">Finition</th>
          <th nzColumnKey="firstIntervention" colspan="2">1ère intervention</th>
          <th nzColumnKey="vehicleVeryDirty" colspan="2">Véhicule très sale</th>
          <th nzColumnKey="upholsteryStainRemoval" [colspan]="serviceUpholsteryStainRemovals.length">Détachage sellerie</th>
          <th nzColumnKey="carpetStainRemoval" [colspan]="serviceCarpetStainRemovals.length">Détachage moquette</th>
        </tr>
        <tr>
          <th nzColumnKey="vehicleStateEnabled-true">Oui</th>
          <th nzColumnKey="vehicleStateEnabled-false">Non</th>
          <th nzColumnKey="conveying-true">Oui</th>
          <th nzColumnKey="conveying-false">Non</th>
          <th nzColumnKey="sticking-true">Oui</th>
          <th nzColumnKey="sticking-false">Non</th>
          <th nzColumnKey="desticking-true">Oui</th>
          <th nzColumnKey="desticking-false">Non</th>
          <th nzColumnKey="contactZoneDisinfection-true">Oui</th>
          <th nzColumnKey="contactZoneDisinfection-false">Non</th>
          <th nzColumnKey="interiorDisinfection-true">Oui</th>
          <th nzColumnKey="interiorDisinfection-false">Non</th>
          <th *ngFor="let serviceFinishing of serviceFinishings" [nzColumnKey]="'serviceFinishing-' + serviceFinishing">{{ serviceFinishing | serviceFinishingName}}</th>
          <th nzColumnKey="firstIntervention-true">Oui</th>
          <th nzColumnKey="firstIntervention-false">Non</th>
          <th nzColumnKey="vehicleVeryDirty-true">Oui</th>
          <th nzColumnKey="vehicleVeryDirty-false">Non</th>
          <th *ngFor="let serviceUpholsteryStainRemoval of serviceUpholsteryStainRemovals" [nzColumnKey]="'serviceUpholsteryStainRemoval-' + serviceUpholsteryStainRemoval">{{ serviceUpholsteryStainRemoval | serviceUpholsteryStainRemovalName}}</th>
          <th *ngFor="let serviceCarpetStainRemoval of serviceCarpetStainRemovals" [nzColumnKey]="'serviceCarpetStainRemoval-' + serviceCarpetStainRemoval">{{ serviceCarpetStainRemoval | serviceCarpetStainRemovalName}}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let row of data?.data">
            <td nzLeft *ngIf="selectedRole === UserRoleType.customerSite">
              <span>{{ row?.customer?.name }}</span>
            </td>
            <td nzLeft>
              <span *ngIf="selectedRole === UserRoleType.customer">{{ row?.customer?.name}}</span>
              <span *ngIf="selectedRole === UserRoleType.customerSite">{{ row?.customerSite?.name}}</span>
              <span *ngIf="selectedRole === UserRoleType.structure">{{ row?.structure?.name}}</span>
            </td>
            <td>{{ getTypeName(row.type) }}</td>
            <td>{{ row.nb }}</td>
            <td>{{ row.nbVehicleStateEnabled }}</td>
            <td>{{ row.nbVehicleStateDisabled }}</td>
            <td>{{ row.nbConveying }}</td>
            <td>{{ row.nbNoConveying }}</td>
            <td>{{ row.nbSticking }}</td>
            <td>{{ row.nbNoSticking }}</td>
            <td>{{ row.nbDesticking }}</td>
            <td>{{ row.nbNoDesticking }}</td>
            <td>{{ row.nbContactZoneDisinfection }}</td>
            <td>{{ row.nbNoContactZoneDisinfection }}</td>
            <td>{{ row.nbInteriorDisinfection }}</td>
            <td>{{ row.nbNoInteriorDisinfection }}</td>
            <td>{{ row.nbFinishingClassic }}</td>
            <td>{{ row.nbFinishingEmployeeDiscount }}</td>
            <td>{{ row.nbFinishingRestitution }}</td>
            <td>{{ row.nbFinishingFleetManagement }}</td>
            <td>{{ row.nbFirstIntervention }}</td>
            <td>{{ row.nbNotFirstIntervention }}</td>
            <td>{{ row.nbVehicleVeryDirty }}</td>
            <td>{{ row.nbVehicleNotVeryDirty }}</td>
            <td>{{ row.nbUpholsteryStainRemovalDriver }}</td>
            <td>{{ row.nbUpholsteryStainRemovalPassenger }}</td>
            <td>{{ row.nbUpholsteryStainRemovalBackLeft }}</td>
            <td>{{ row.nbUpholsteryStainRemovalBackRight }}</td>
            <td>{{ row.nbCarpetStainRemovalDriver }}</td>
            <td>{{ row.nbCarpetStainRemovalPassenger }}</td>
            <td>{{ row.nbCarpetStainRemovalBackLeft }}</td>
            <td>{{ row.nbCarpetStainRemovalBackRight }}</td>
            <td>{{ row.nbCarpetStainRemovalBoot }}</td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    <ng-template #errorTemplate>
      <nz-result
        nzTitle="Erreur de chargement"
        nzStatus="error"
        nzSubTitle="Une erreur est survenue lors du chargement du reporting">
        <div nz-result-extra>
          <button nz-button nzType="primary" (click)="loadData()">
            Réessayer
            <i nz-icon nzType="reload"></i>
          </button>
        </div>
      </nz-result>
    </ng-template>
    <ng-template #emptyTemplate>
      <nz-empty
        nzNotFoundImage="simple"
        nzNotFoundContent="Il n'y a encore aucune données pour le moment.">
      </nz-empty>
    </ng-template>
  </div>
</nz-card>

<ng-template #exportForm let-params>
  <form nz-form [formGroup]="params.exportForm">
    <h5 [style.marginTop]="0" [style.marginBottom]="'16px'">Informations</h5>
    <nz-form-item>
      <nz-form-label [nzSm]="10" nzFor="role">Grouper par</nz-form-label>
      <nz-form-control [nzSm]="14">
        <nz-select formControlName="role">
          <nz-option [nzLabel]="UserRoleType.customer | roleName" [nzValue]="UserRoleType.customer"></nz-option>
          <nz-option [nzLabel]="UserRoleType.customerSite | roleName" [nzValue]="UserRoleType.customerSite"></nz-option>
          <nz-option [nzLabel]="UserRoleType.structure | roleName" [nzValue]="UserRoleType.structure"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSm]="10" nzFor="dates">Dates</nz-form-label>
      <nz-form-control [nzSm]="14">
        <nz-range-picker id="dates" name="dates" formControlName="dates" [nzFormat]="'dd/MM/yyyy'" [nzAllowClear]="false" [nzRanges]="dateRanges"></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
    <h5 [style.marginTop]="0" [style.marginBottom]="'16px'">Options</h5>
    <p [style.marginBottom]="0">Nombre de résultats :</p>
    <nz-radio-group formControlName="page">
      <label nz-radio-button nzValue="current" class="radio-line">Page actuelle</label>
      <label nz-radio-button nzValue="all" class="radio-line">Tous les résultats</label>
    </nz-radio-group>
    <nz-form-item>
      <nz-form-label [nzSm]="24" nzFor="filename" [style.textAlign]="'left'">Nom du fichier</nz-form-label>
      <nz-form-control>
        <nz-input-group nzAddOnAfter=".xlsx">
          <input nz-input id="filename" name="filename" placeholder="export" formControlName="filename">
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>
